import { render, staticRenderFns } from "./zhulao.vue?vue&type=template&id=66f3a0a2&scoped=true"
import script from "./zhulao.vue?vue&type=script&lang=js"
export * from "./zhulao.vue?vue&type=script&lang=js"
import style0 from "./zhulao.vue?vue&type=style&index=0&id=66f3a0a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f3a0a2",
  null
  
)

export default component.exports